exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.data-source {\n  font-size: 0.75em;\n}\n", ""]);

// exports
